export const PAGE_CACHE_KEY = 'page';
export const COMPONENT_CACHE_PREFIX = 'component:';
export const SEO_REDIRECTION_PREFIX = 'seo_redirection:';
